import Vue from 'vue'
import App from './App'

import store from './store'
import router from '@/router'
import './config/element.js'

import '@/assets/gloabol.css'
// import 'element-ui/lib/theme-chalk/index.css'
// import 'element-ui/lib/theme-chalk/base.css';
import './components/content.less'
import utils from '@/utils/utils'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题样式

// import '@vant/touch-emulator';

import 'highlight.js/styles/github.css'
import '@/assets/css/hljs/atom-one-dark.less'
import '@/assets/css/hljs/atom-one-light.less'

// 官网样式
import '../public/static/static/css/bootstrap.min.css';
import '../public/static/static/css/font-awesome.min.css';
import '../public/static/static/css/all.min.css';
import '../public/static/static/css/css2.css';
import '../public/static/static/css/owl.carousel.min.css';
import '../public/static/static/css/owl.theme.default.min.css';
import '../public/static/static/css/style.min.css';
import '../public/static/static/css/themify-icons.css';

Vue.use(ElementUI)

import JwChat from 'jwchat'
/* 在 0.2.041 之前的版本需要引入 css */
// import 'jwchat/lib/JwChat.css';
Vue.use(JwChat)

Vue.prototype.$utils = utils

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
